import { IBucketProduct } from 'featureSliced/shared/store/reducers/QRMenuBucketReducer/types'
import { IDiscount } from 'featureSliced/shared/store/reducers/SpecialsReducer/types'

export const getProductDiscount = (
  product: IBucketProduct,
  discounts: IDiscount[]
) =>
  discounts?.find((disc) => disc.productId === product.productId)
    ?.discountPercentage
